import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { deliverySoftwareRouter } from './routing/deliverySoftwareRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { deliverySoftwareAccessControl } from './access-control/deliverySoftwareAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'delivery-software',
  totem: {
    tool: 'delivery-software-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [deliverySoftwareRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsLabor,
      subNavItems: [
        {
          type: 'item',
          labelId: 'deliverySoftwareDomain.deliveryRoutes.title',
          llmDescription:
            'Delivery Routes dashboard to view and manage partner-managed bulk delivery routes for truck fleet operations.',
          route: 'delivery-software-delivery-routes',
          accessControl: deliverySoftwareAccessControl,
          id: 'nav-item-delivery-routes',
          position: 8,
          positionNavV2: 5,
          inToolPermissions: [
            {
              slug: Permission.PartnerBulkDeliveryRouteView,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.PartnerBulkDeliveryRouteView,
            },
            {
              slug: Permission.PartnerBulkDeliveryRouteModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.PartnerBulkDeliveryRouteModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
